// extracted by mini-css-extract-plugin
export default {"MktLangSelect":"UC_5JFH"};